import React from 'react';

import usePage from '@dashboard/hooks/usePage';
import { PAGE_TYPES } from '@dashboard/enums/page-types';

import PageEditView from '../../components/PageEditView';
import { editorSection } from '../../pageEditTabs';
import OrderBumpsForm from '../PageProduct/components/OrderBumps/OrderBumpsForm';
import { getOfferCopy } from '../PageProduct/components/OrderBumps/offerCopy';

export const getOrderBumpsTabPath = page =>
  page.type === PAGE_TYPES.EVENT ? 'add-ons' : 'order-bumps';

const DESCRIPTIONS = {
  [PAGE_TYPES.EVENT]:
    'Offer extras such as merchandise or parking that the customer can add to their booking with one click.',
  [PAGE_TYPES.CHECKOUT]: 'Offer products your customer can accept with one click before paying.',
};

const PageOrderBumps = () => {
  const { page } = usePage();

  return (
    <PageEditView
      tabs={[
        {
          ...editorSection(getOrderBumpsTabPath(page), '', { page }),
          label: getOfferCopy(page).Plural,
          description: DESCRIPTIONS[page.type],
          component: <OrderBumpsForm />,
        },
      ]}
    />
  );
};

export default PageOrderBumps;
